const grades = {
  1.1: "一年級",
  1.2: "二年級",
  1: "升國一",
  2: "升高一",
  3: "三年級",
  4: "四年級",
  5: "五年級",
  6: "六年級",
  7: "國一",
  8: "國二",
  9: "國三",
  10: "高一",
  11: "高二",
  12: "高三"
};

export const getGradeName = key => {
  return grades[key];
};

export const getGradeKey = name => {
  return Object.keys(grades).find(key => grades[key] == name);
};
